import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { get_candidate_profile_data_action } from "../../../redux/_actions";
import { useNavigate } from "react-router-dom";

function useEditCandidateProfile(props) {
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState({});


  const dispatch = useDispatch();
  const navigate = useNavigate();

  //get data from redux
  const { userProfileData } = useSelector(
    (state) => state.get_candidate_profile_data_reducer
  );

  useEffect(() => {
    callApi();
  }, []);

  useEffect(() => {
    if (userProfileData?.data) {
      setUserData(userProfileData?.data);
    }
  }, [userProfileData]);

  const callApi = async () => {
    setLoading(true)
    await dispatch(get_candidate_profile_data_action());
    setLoading(false)
  }

  const onNavigateBack = () => navigate(-1);

  return {
    loading,
    userData,
    onNavigateBack
  };
}
export default useEditCandidateProfile;
